"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACFileUpload = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var antd_1 = require("antd");
var icons_1 = require("@ant-design/icons");
var XLSX = __importStar(require("xlsx"));
var FormInputLabel_1 = __importDefault(require("./FormInputLabel"));
var Dragger = antd_1.Upload.Dragger;
var ACFileUpload = function (_a) {
    var _b = _a.accept, accept = _b === void 0 ? '.csv,.xlsx,.xls' : _b, _c = _a.maxFileSize, maxFileSize = _c === void 0 ? 10 : _c, _d = _a.maxCount, maxCount = _d === void 0 ? 10 : _d, _e = _a.required, required = _e === void 0 ? false : _e, onFileUpload = _a.onFileUpload, onFileRemove = _a.onFileRemove, _f = _a.multiple, multiple = _f === void 0 ? false : _f, _g = _a.disabled, disabled = _g === void 0 ? false : _g, _h = _a.className, className = _h === void 0 ? '' : _h, _j = _a.hintText, hintText = _j === void 0 ? 'Support for file upload' : _j, name = _a.name, _k = _a.label, label = _k === void 0 ? '' : _k, _l = _a.extractColumns, extractColumns = _l === void 0 ? false : _l, _m = _a.uploadType, uploadType = _m === void 0 ? 'file' : _m, _o = _a.serializeFile, serializeFile = _o === void 0 ? false : _o;
    var _p = (0, react_1.useState)([]), fileList = _p[0], setFileList = _p[1];
    var _q = (0, react_1.useState)(false), isProcessing = _q[0], setIsProcessing = _q[1];
    var _r = (0, react_1.useState)([]), uploadedFiles = _r[0], setUploadedFiles = _r[1]; // Store multiple files
    // Normalize: ensure we always get a native File
    var getRawFile = function (f) {
        var file = (f === null || f === void 0 ? void 0 : f.originFileObj) || f;
        // Validate it's actually a File object
        return file instanceof File ? file : null;
    };
    var isSpreadsheet = function (fileName) {
        if (!fileName)
            return false;
        var lower = fileName.toLowerCase();
        return (lower.endsWith('.csv') ||
            lower.endsWith('.xlsx') ||
            lower.endsWith('.xls'));
    };
    // Convert File to Base64
    var convertFileToBase64 = function (file) {
        return new Promise(function (resolve, reject) {
            var reader = new FileReader();
            reader.onload = function () { return resolve(reader.result); };
            reader.onerror = reject;
            reader.readAsDataURL(file);
        });
    };
    var processFile = (0, react_1.useCallback)(function (rawFile, extractDataRows) {
        if (extractDataRows === void 0) { extractDataRows = true; }
        return new Promise(function (resolve, reject) {
            var reader = new FileReader();
            reader.onload = function (e) {
                var _a;
                try {
                    var result = (_a = e.target) === null || _a === void 0 ? void 0 : _a.result;
                    if (!result) {
                        reject(new Error('Empty file content'));
                        return;
                    }
                    var jsonData = [];
                    var fileName_1 = rawFile.name || '';
                    if (fileName_1.toLowerCase().endsWith('.csv')) {
                        var text = result;
                        var lines = text.split('\n').filter(function (line) { return line.trim(); });
                        if (!lines.length) {
                            reject(new Error('File is empty'));
                            return;
                        }
                        var headers_1 = lines[0]
                            .split(',')
                            .map(function (h) { return h.trim().replace(/"/g, ''); });
                        if (!extractDataRows) {
                            // Return only headers for 'raw' type
                            resolve({ headers: headers_1 });
                            return;
                        }
                        var rows_1 = lines
                            .slice(1)
                            .map(function (line) {
                            return line.split(',').map(function (cell) { return cell.trim().replace(/"/g, ''); });
                        });
                        jsonData = __spreadArray([headers_1], rows_1, true);
                    }
                    else {
                        var data = new Uint8Array(result);
                        var workbook = XLSX.read(data, { type: 'array' });
                        var worksheet = workbook.Sheets[workbook.SheetNames[0]];
                        if (!extractDataRows) {
                            // Extract only headers (first row)
                            var range = XLSX.utils.decode_range(worksheet['!ref'] || 'A1');
                            var headers_2 = [];
                            for (var col = range.s.c; col <= range.e.c; col++) {
                                var cellAddress = XLSX.utils.encode_cell({ r: 0, c: col });
                                var cell = worksheet[cellAddress];
                                headers_2.push(cell ? String(cell.v) : "Column".concat(col + 1));
                            }
                            resolve({ headers: headers_2 });
                            return;
                        }
                        jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
                    }
                    if (!jsonData.length) {
                        reject(new Error('File is empty'));
                        return;
                    }
                    var headers_3 = jsonData[0];
                    var rows = jsonData.slice(1).map(function (row) {
                        var obj = {};
                        headers_3.forEach(function (header, index) {
                            obj[header] =
                                row[index] !== undefined && row[index] !== null
                                    ? row[index]
                                    : '';
                        });
                        return obj;
                    });
                    resolve({ data: rows, headers: headers_3 });
                }
                catch (err) {
                    reject(err);
                }
            };
            reader.onerror = function () { return reject(new Error('Failed to read file')); };
            var fileName = rawFile.name || '';
            if (fileName.toLowerCase().endsWith('.csv')) {
                reader.readAsText(rawFile);
            }
            else {
                reader.readAsArrayBuffer(rawFile);
            }
        });
    }, []);
    var handleUpload = function (options) { return __awaiter(void 0, void 0, void 0, function () {
        var rawFile, safeFileName, safeFileType, safeFileSize, result_1, base64, _a, data, headers, headers, error_1;
        var _b, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    rawFile = getRawFile(options.file);
                    if (!rawFile) {
                        antd_1.message.error('Invalid file');
                        (_b = options.onError) === null || _b === void 0 ? void 0 : _b.call(options, new Error('Invalid file'));
                        return [2 /*return*/];
                    }
                    _e.label = 1;
                case 1:
                    _e.trys.push([1, 9, 10, 11]);
                    setIsProcessing(true);
                    safeFileName = rawFile.name || 'unnamed';
                    safeFileType = rawFile.type || 'application/octet-stream';
                    safeFileSize = rawFile.size || 0;
                    result_1 = {
                        type: uploadType,
                        fileName: safeFileName,
                        fileType: safeFileType,
                        fileSize: safeFileSize,
                    };
                    if (!serializeFile) return [3 /*break*/, 3];
                    return [4 /*yield*/, convertFileToBase64(rawFile)];
                case 2:
                    base64 = _e.sent();
                    result_1.fileBase64 = base64;
                    return [3 /*break*/, 4];
                case 3:
                    result_1.file = rawFile;
                    _e.label = 4;
                case 4:
                    if (!(extractColumns && isSpreadsheet(safeFileName))) return [3 /*break*/, 8];
                    if (!(uploadType === 'data')) return [3 /*break*/, 6];
                    return [4 /*yield*/, processFile(rawFile, true)];
                case 5:
                    _a = _e.sent(), data = _a.data, headers = _a.headers;
                    result_1.headers = headers;
                    result_1.data = data;
                    return [3 /*break*/, 8];
                case 6:
                    if (!(uploadType === 'raw')) return [3 /*break*/, 8];
                    return [4 /*yield*/, processFile(rawFile, false)];
                case 7:
                    headers = (_e.sent()).headers;
                    result_1.headers = headers;
                    _e.label = 8;
                case 8:
                    onFileUpload === null || onFileUpload === void 0 ? void 0 : onFileUpload(result_1);
                    (_c = options.onSuccess) === null || _c === void 0 ? void 0 : _c.call(options, rawFile);
                    // If multiple is enabled, collect files in array
                    if (multiple) {
                        setUploadedFiles(function (prev) {
                            var updated = __spreadArray(__spreadArray([], prev, true), [result_1], false);
                            // Notify parent with array of all files
                            onFileUpload === null || onFileUpload === void 0 ? void 0 : onFileUpload(updated.length === 1 ? updated[0] : updated);
                            return updated;
                        });
                    }
                    return [3 /*break*/, 11];
                case 9:
                    error_1 = _e.sent();
                    console.error('Upload error:', error_1);
                    (_d = options.onError) === null || _d === void 0 ? void 0 : _d.call(options, error_1);
                    antd_1.message.error("Failed to upload ".concat((rawFile === null || rawFile === void 0 ? void 0 : rawFile.name) || 'file', ": ").concat(error_1 instanceof Error ? error_1.message : 'Unknown error'));
                    return [3 /*break*/, 11];
                case 10:
                    setIsProcessing(false);
                    return [7 /*endfinally*/];
                case 11: return [2 /*return*/];
            }
        });
    }); };
    var handleRemove = function (file) {
        // Remove from uploadedFiles array
        setUploadedFiles(function (prev) {
            var updated = prev.filter(function (f) { return f.fileName !== file.name; });
            // Notify parent with updated array
            if (multiple && updated.length > 0) {
                onFileUpload === null || onFileUpload === void 0 ? void 0 : onFileUpload(updated.length === 1 ? updated[0] : updated);
            }
            else {
                onFileRemove === null || onFileRemove === void 0 ? void 0 : onFileRemove();
            }
            return updated;
        });
        onFileRemove === null || onFileRemove === void 0 ? void 0 : onFileRemove();
        return true;
    };
    var uploadProps = {
        name: 'file',
        multiple: multiple,
        maxCount: maxCount,
        disabled: disabled || isProcessing,
        accept: accept,
        fileList: fileList,
        customRequest: handleUpload,
        onRemove: handleRemove,
        onChange: function (_a) {
            var newFileList = _a.fileList;
            return setFileList(newFileList);
        },
        beforeUpload: function (file) {
            var rawFile = getRawFile(file);
            if (!rawFile) {
                antd_1.message.error('Invalid file object');
                return false;
            }
            var safeFileName = rawFile.name || 'unknown-file';
            var safeFileType = rawFile.type || '';
            var safeFileSize = rawFile.size || 0;
            // validate extension
            var isValidType = accept.split(',').some(function (type) {
                var cleanType = type.replace('.', '').trim();
                var fileName = safeFileName.toLowerCase();
                return fileName.endsWith(cleanType) || safeFileType.includes(cleanType);
            });
            if (!isValidType) {
                antd_1.message.error("Please upload files with extensions: ".concat(accept));
                return false;
            }
            // validate size
            var isValidSize = safeFileSize / 1024 / 1024 < maxFileSize;
            if (!isValidSize) {
                antd_1.message.error("File size must be less than ".concat(maxFileSize, "MB"));
                return false;
            }
            return true;
        },
    };
    return ((0, jsx_runtime_1.jsxs)("div", { className: className, children: [(0, jsx_runtime_1.jsx)(FormInputLabel_1.default, { label: label || '', required: required }), (0, jsx_runtime_1.jsxs)(Dragger, __assign({}, uploadProps, { style: { padding: '4px' }, children: [(0, jsx_runtime_1.jsx)("p", { className: "ant-upload-drag-icon", children: (0, jsx_runtime_1.jsx)(icons_1.InboxOutlined, { style: { fontSize: '24px', color: '#000' } }) }), (0, jsx_runtime_1.jsxs)("p", { className: "ant-upload-hint", children: [hintText, ". Maximum file size: ", maxFileSize, "MB"] })] }))] }, name));
};
exports.ACFileUpload = ACFileUpload;
